import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://backpetbrief.gtsf.com.mx'
    //baseURL: 'http://arqibero.gtsf.com.mx'
    //baseURL: 'http://172.22.128.136:9539'
    //baseURL: 'http://192.168.1.66:9816'
});

export default instance;
